const configs = {
  local: {
    STAGE: 'local',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_LOCAL,
    REZ_API_KEY: ''
  },
  dev1: {
    STAGE: 'dev1',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_DEV,
    REZ_API_KEY: ''
  },
  dev2: {
    STAGE: 'dev2',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_DEV2,
    REZ_API_KEY: ''
  },
  qam1: {
    STAGE: 'qam1',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_QAM1,
    REZ_API_KEY: ''
  },
  qam2: {
    STAGE: 'qam2',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_QAM2,
    REZ_API_KEY: ''
  },
  cnpb: {
    STAGE: 'cnpb',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_CNPB,
    REZ_API_KEY: ''
  },
  cnpg: {
    STAGE: 'cnpg',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_CNPG,
    REZ_API_KEY: ''
  },
  prod: {
    STAGE: 'prod',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_PROD,
    REZ_API_KEY: ''
  },
  green: {
    STAGE: 'green',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_GREEN,
    REZ_API_KEY: ''
  },
  blue: {
    STAGE: 'blue',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_BLUE,
    REZ_API_KEY: ''
  },
  qaa1: {
    STAGE: 'qaa1',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_QAA1,
    REZ_API_KEY: ''
  },
  qaa2: {
    STAGE: 'qaa2',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_QAA2,
    REZ_API_KEY: ''
  },
  demo: {
    STAGE: 'demo',
    REZ_URL: process.env.REACT_APP_REZ_API_BASE_URL_DEMO,
    REZ_API_KEY: ''
  }
}
const stage = process.env.REACT_APP_STAGE ?? 'local'

export default configs[stage]
